import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import StickyReportCTA from "./StickyReportCTA";
import HelpAgent from "./HelpAgent";
import ViewerCount from "./ViewerCount";

const AUTH_PATHS = new Set(["/login", "/register", "/auth/callback"]);

const Layout = ({ children }) => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [pathname]);
  const showViewerCount = !AUTH_PATHS.has(pathname);
  return (
    <div className="App min-h-screen flex flex-col w-full max-w-[100vw] overflow-x-hidden" data-testid="app-layout">
      {showViewerCount && <ViewerCount />}
      <Header />
      <main className="flex-1" data-testid="main-content">{children}</main>
      <Footer />
      <StickyReportCTA />
      <HelpAgent />
    </div>
  );
};

export default Layout;
